import { useEffect, useRef } from 'react';
import { Grid } from 'antd';

/**
 * 跨過手機／桌機斷點（例如手機轉橫向 ≥ 768px）時呼叫 `reset`。
 * 手機與桌機是兩套不受控的篩選欄，切換後新的一套是空的；
 * 若不同步清掉上層的篩選值，畫面會變成「篩選欄空白、列表卻仍在篩選」。
 * 首次決定斷點（undefined → true/false）不算切換。
 */
export function useResetOnBreakpoint(reset: () => void): void {
  const md = Grid.useBreakpoint().md;
  const prev = useRef(md);
  const resetRef = useRef(reset);
  resetRef.current = reset;
  useEffect(() => {
    if (prev.current !== undefined && md !== undefined && prev.current !== md) resetRef.current();
    prev.current = md;
  }, [md]);
}
